import type { SVGProps } from "react";
const SvgWebsiteClick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    fontSize="1rem"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.372 18.476H3.657a1.463 1.463 0 0 1-1.461-1.461V7.754h18.347v5.255a.682.682 0 0 0 1.363 0V4.408a2.82 2.82 0 0 0-2.817-2.817H3.649A2.82 2.82 0 0 0 .834 4.408v12.607a2.827 2.827 0 0 0 2.824 2.824h9.715a.682.682 0 0 0 0-1.363M3.65 2.954h15.439c.802 0 1.454.652 1.454 1.454V6.39H2.196V4.408c0-.801.652-1.454 1.454-1.454"
    />
    <path
      fill="currentColor"
      d="M4.536 5.276a.609.609 0 1 0 0-1.217.609.609 0 0 0 0 1.217M6.68 5.276a.609.609 0 1 0 0-1.217.609.609 0 0 0 0 1.217M8.825 5.276a.609.609 0 1 0 0-1.217.609.609 0 0 0 0 1.217M22.432 15.433l-6.529-1.986a1.36 1.36 0 0 0-1.358.34 1.36 1.36 0 0 0-.34 1.358l1.986 6.53c.176.577.68.955 1.282.964h.021a1.34 1.34 0 0 0 1.289-.927l.928-2.759 2.76-.93a1.34 1.34 0 0 0 .926-1.31 1.34 1.34 0 0 0-.965-1.28m-3.156 2.23c-.4.136-.72.455-.855.855l-.926 2.76-1.985-6.525 6.526 1.981z"
    />
  </svg>
);
export default SvgWebsiteClick;
